import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const WebAboutRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getAboutList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetAbout}`, {
    params: {
      search: values?.search
    }
  }),

  postDeleteAbout: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webAboutDelete}?id=${id}`),
  postUpdateAbout: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateAbout}`, values),
  getAboutDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webAboutDetails}?id=${id}`),
  createAbout: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateAbout}`, values),
  
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default WebAboutRequest